import styled from 'styled-components';

export const InfoElement = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 14px;

  & > div:first-child {
    margin-right: 8px;
    white-space: nowrap;
  }

  & > div:last-child {
    word-break: break-all;
  }
`;

export const InfoWrapper = styled.div`
  display: flex;

  & > div:first-child,
  & > div:last-child {
    & > div > :last-child {
      max-width: 360px;
    }
  }
`;

export const InfoBlock = styled.div`
  :not(:last-child) {
    margin-right: 48px;
  }
`;

export const ViewContainer = styled.div`
  max-width: 960px;
`;
